import logo from './images/logo.svg'

export const IMAGES = {
  logo,
}
